import { StudyInfoDrawer } from '@/entities/study';
import { DOUBLE_HYPHEN_BULLET } from '@/shared/config';
import { Table } from 'antd';
import { useMemo } from 'react';
import { t } from 'ttag';
import { useSupportTableStudy } from './useSupportTableStudy';
import { formatterDummyField, studyFidFormatter } from './handler';
import type { SupportTableStudyProps } from './supportTableStudy.types';
import './style.scss';

/**
 * Table of the studies attached to a change-study-type support request. Builds columns for the row number, the study ID rendered through studyFidFormatter bound to toggleDisplayDrawer, and the current and new study types, renders them unpaginated over data, and mounts StudyInfoDrawer driven by useSupportTableStudy state.
 *
 * @param data - Study rows of the support request.
 * @returns The study table with its info drawer.
 */
const SupportTableStudy = ({ data }: SupportTableStudyProps) => {
  const { state, toggleDisplayDrawer } = useSupportTableStudy();

  /**
   * Column definitions of the support request study table. Pairs a row-index column with a study ID column rendered through studyFidFormatter bound to toggleDisplayDrawer, followed by the old and new studyType columns.
   *
   * @returns The antd column configuration array.
   */
  const columns = useMemo(
    () => [
      {
        title: '#',
        render: formatterDummyField,
      },
      {
        dataIndex: ['study', 'friendlyId'],
        title: t`Study ID`,
        render: (cell: any, row: any, rowIndex: any) =>
          studyFidFormatter(cell, row, rowIndex, toggleDisplayDrawer),
      },
      {
        dataIndex: ['studyType', 'old'],
        title: t`Current study type`,
        render: (cell: any) => cell || DOUBLE_HYPHEN_BULLET,
      },
      {
        dataIndex: ['studyType', 'new'],
        title: t`New study type`,
        render: (cell: any) => cell || DOUBLE_HYPHEN_BULLET,
      },
    ],
    [],
  );

  // const data = [...Array(5)].map((_, index) => ({
  //   studyFid: index,
  // }));

  return (
    <>
      <div className="studies-comment-table">
        <Table
          columns={columns}
          dataSource={data || []}
          pagination={false}
          key="study"
          className="table-study-list"
        />
      </div>
      <StudyInfoDrawer
        visible={state.isVisibleStudyInfoDrawer}
        fetchStudyId={state.fetchStudyId}
        handleClickCloseButton={toggleDisplayDrawer}
      />
    </>
  );
};

export default SupportTableStudy;
